<template>
  <div>
    <!-- 位置名称 动态 -->
    <bread-crumb></bread-crumb>
    <div class="pgcQaDetail-info">
      {{ curQa?.manufacturer }} {{ curQa?.genericName || curQa?.skuName }} {{ curQa?.specification }}的问答明细
    </div>
    <el-form ref="pgc-search-form" :model="form" label-width="100px" class="pgcQa-search">
      <!-- <el-form-item label="回答是否为空">
        <el-select v-model="form.ifHaveAnswer" placeholder="请选择">
          <el-option
            key="99"
            label="请选择"
            value=""
          ></el-option>
          <el-option
            key="0"
            label="是"
            value="0"
          ></el-option>
          <el-option
            key="1"
            label="否"
            value="1"
          ></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="问答类型">
        <el-select v-model="form.pinLabel" placeholder="请选择">
          <el-option key="99" label="全部" value=""></el-option>
          <el-option key="15" label="药师问答" value="15"></el-option>
          <el-option key="1" label="医生问答" value="16"></el-option>
          <el-option key="17" label="营养师问答" value="17"></el-option>
          <el-option key="18" label="护士问答" value="18"></el-option>
          <el-option key="19" label="视光师问答" value="19"></el-option>
          <el-option key="20" label="中医问答" value="20"></el-option>
          <el-option key="30" label="一问一答" value="30"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="问题">
        <el-input v-model="form.question" placeholder="请输入">
        </el-input>
      </el-form-item>
      <el-form-item label="回答">
        <el-input v-model="form.answer" placeholder="请输入">
        </el-input>
      </el-form-item>
      <el-form-item label="专家资质">
        <el-input v-model="form.expertId" placeholder="请输入">
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-button @click="reset">重置</el-button>
        <el-button type="primary" @click="onSumit">查询</el-button>
      </el-form-item>
    </el-form>
    <div class="pgcQa-iebtns">
      <el-button size="small" type="primary" @click="toImportPage">批量新增</el-button>
      <el-button size="small" type="primary" @click="toExportPage">批量删除</el-button>
    </div>
    <div class="pgcQa--tabel">
      <div class="base-table">
        <div class="base-table-table">
          <el-table :data="pgcQaList" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="100">
            </el-table-column>
            <el-table-column prop="productId" label="ID" width="120">
            </el-table-column>
            <el-table-column prop="pinLabelStr" label="问答类型" width="120">
            </el-table-column>
            <el-table-column prop="question" width="300" label="问题">
            </el-table-column>
            <el-table-column prop="answer" label="回答" width="350">
            </el-table-column>
            <el-table-column prop="expertId" label="专家资质" width="150">
            </el-table-column>
            <el-table-column prop="docName" label="专家姓名" width="120">
            </el-table-column>
            <el-table-column prop="doctorTitleName" label="职称" width="120">
            </el-table-column>
            <el-table-column prop="departName" label="科室">
            </el-table-column>
            <el-table-column prop="hospitalName" label="医院" width="300">
            </el-table-column>
            <el-table-column label="操作" width="200">
              <template slot-scope="scope">
                <el-button @click="handleEdit(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="handleDelete(scope.row)" type="text" size="small">删除</el-button>
                <el-button v-if="scope.row.topStatus !== 1" @click="handleToTop(scope.row, scope.$index)" type="text"
                  size="small">置顶</el-button>
                <el-button v-if="scope.row.topStatus === 1" @click="handleCancelTop(scope.row, scope.$index)"
                  type="text" size="small">取消置顶</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <pagination @sizePageChange="paginationChangeProduct" :paginationDatas="paginationDataProduct" />
    <el-dialog title="确认" :visible.sync="deleteDialogVisible" width="30%" center>
      <span>确认删除？</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="multDelete">确 认</el-button>
        <el-button @click="deleteDialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import breadCrumb from "@/components/wiki/breadCrumb";
import pagination from "@/components/wiki/pagination";

import { pgcSelectDrugQuestionAndAnswers, pgcBatchdelQuestion, healthPgcTopPgcQuestionId } from "@/api/man";

export default {
  name: "pgcQaDetail",
  data() {
    return {
      form: {
        ifHaveAnswer: ''
      },
      // 当前问答
      curQa: {},
      // 列表数据
      pgcQaList: [],
      // 分页
      paginationDataProduct: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      // 当前选中的问答
      selectEdQas: [],
      deleteDialogVisible: false
    }
  },
  components: {
    breadCrumb,
    pagination
  },
  created() {
    // this.getDrugQuestionAndAnswers();
    const qalist = localStorage.getItem('pgcQaList');
    console.log("🚀 ~ file: pgcQaDetail.vue:115 ~ created ~ qalist:", qalist, this.$route)
    if (qalist) {
      const qalistArr = JSON.parse(qalist);
      const curDurgId = this.$route.query.drugId
      this.curQa = parseInt(this.$route.query.type) == 1 ? qalistArr.find((qa) => qa.drugId == curDurgId) : qalistArr.find((qa) => qa.skuId == curDurgId)
      console.log("==== curQa", qalistArr, curDurgId, this.curQa)
      this.getDrugQuestionAndAnswers()
    }
  },
  methods: {
    handleCancelTop(rows, index) {
      console.log(rows, index)
      healthPgcTopPgcQuestionId({
        drugId: this.$route.query.drugId,
        ...rows,
        topStatus: 0
      }).then(res => {
        if (res) {
          this.onSumit(null, this.paginationDataProduct.currentPage)
        }
      })
    },
    handleToTop(rows, index) {
      healthPgcTopPgcQuestionId({
        drugId: this.$route.query.drugId,
        ...rows,
        topStatus: 1
      }).then(res => {
        console.log(res, 'res')
        if (res) {
          this.onSumit(null, this.paginationDataProduct.currentPage)
        }
      })
    },
    // 获取数据
    getDrugQuestionAndAnswers(val) {
      if (val) {
        this.paginationDataProduct.currentPage = val;
      }

      pgcSelectDrugQuestionAndAnswers({
        pageSize: this.paginationDataProduct.pageSize,
        pageNum: this.paginationDataProduct.currentPage,
        productId: this.curQa?.drugId || this.$route.query.drugId,
        pgcDrugId: this.curQa?.pgcDrugId,
        type: parseInt(this.$route.query.type) || 1,
        ...this.form
      }).then(res => {
        console.log("🚀 ~ file: pgcQaDetail.vue:135 ~ getDrugQuestionAndAnswers ~ res:", res)
        this.pgcQaList = res.list;
        // 本地存储，用于编辑页展示和查询
        localStorage.setItem('drugQuestionAndAnswers', JSON.stringify(res.list));
        this.paginationDataProduct.total = res.total;
        this.paginationDataProduct.currentPage = res.pageNum;
        this.paginationDataProduct.pageSize = res.pageSize;
      })
    },
    // 搜索
    onSumit(eventData, currentPage) {

      this.paginationDataProduct.currentPage = currentPage || 1;
      console.log('this.paginationDataProduct.currentPage', this.paginationDataProduct.currentPage);
      this.getDrugQuestionAndAnswers();
    },
    // 重置
    reset() {
      this.form = {
        ifHaveAnswer: ''
      }
      this.paginationDataProduct.currentPage = 1;
      this.getDrugQuestionAndAnswers()
    },
    // 切换页码
    paginationChangeProduct(val) {
      this.paginationDataProduct = val;
      console.log('paginationChangeProduct', this.paginationDataProduct)
      this.getDrugQuestionAndAnswers()
    },
    // 多选改变时
    handleSelectionChange(val) {
      console.log("🚀 ~ file: pgcQaDetail.vue:154 ~ handleSelectionChange ~ val:", val)
      this.selectEdQas = val;
    },
    // 跳转 批量新增
    toImportPage() {
      this.$router.push({
        path: '/pgc/import'
      })
    },
    //批量删除
    toExportPage() {
      if (this.selectEdQas.length > 0) {
        this.deleteDialogVisible = true
      }
    },
    // 多选删除
    multDelete() {
      console.log('多选删除', this.selectEdQas);
      this.doDelete(this.selectEdQas)
    },
    // 单个删除
    handleDelete(row) {
      console.log('单个删除', row);
      this.doDelete([row]);
    },
    // 删除方法
    doDelete(val) {
      console.log('删除方法', val);
      let strs = '';
      val.forEach((it) => {
        strs += `,${it.questionId}`
      })
      strs = strs.slice(1);
      console.log("🚀 ~ file: pgcQaDetail.vue:212 ~ doDelete ~ strs:", strs)
      pgcBatchdelQuestion({
        questionIdsStr: strs,
        type: parseInt(this.$route.query.type) || 1,
      }).then(res => {
        console.log("🚀 ~ file: pgcQaDetail.vue:216 ~ doDelete ~ res:", res)
        this.$message('删除成功');
        this.getDrugQuestionAndAnswers()
      })
    },
    // 编辑问答
    handleEdit(row) {
      console.log("🚀 ~ file: pgcQaDetail.vue:210 ~ handleEdit ~ row:", row)
      this.$router.push({
        path: '/pgc/editQas',
        query: {
          drugId: this.curQa.drugId || this.curQa.skuId,
          questionId: row.questionId,
          type: parseInt(this.$route.query.type)
        }
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.pgcQaDetail-info {
  padding: 20px 0px 20px 33px;
  background: #fff;
  margin-bottom: 10px;
  font-size: 14px;
  color: rgb(81, 101, 121);
}

.pgcQa-search {
  display: flex;
  padding: 20px 0px 20px 33px;
  margin-bottom: 10px;
  align-items: center;
  background: #fff;

  .el-form-item {
    margin-bottom: 0;
  }
}
</style>
